export default "__VITE_ASSET__bb920dd6__"